import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { abcAnalysisRoutes } from './abc-analysis.routes';
import {
  WwsAbcAnalysisModuleConfig,
  DEFAULT_WWS_ABC_ANALYSIS_CONFIG,
  SOFTLINE_CONFIG_WWS_ABC_ANALYSIS,
  SOFTLINE_MODULE_WWS_ABC_ANALYSIS,
  SOFTLINE_PERMISSION_WWS_ABC_ANALYSIS,
} from './abc-analysis.shared';

export const provideWwsAbcAnalysisModule = (config?: WwsAbcAnalysisModuleConfig) => {
  return [
    {
      provide: SOFTLINE_CONFIG_WWS_ABC_ANALYSIS,
      useValue: { ...DEFAULT_WWS_ABC_ANALYSIS_CONFIG, ...config },
    },
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_WWS_ABC_ANALYSIS,
        title: '#WWS_ABC_ANALYSIS.TITLE',
        icon: 'fa-regular fa-chart-pie',
        route: '/wws-abc-analysis',
        permission: SOFTLINE_PERMISSION_WWS_ABC_ANALYSIS,
        group: getModuleGroupByName('Statistik'),
      },
      withSoftAppsModuleRoutes({ app: abcAnalysisRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleNavItem([
        {
          name: 'abc-analysis-main',
          title: '#WWS_ABC_ANALYSIS.MAIN_PAGE_TITLE',
          icon: 'fa-regular fa-chart-pie',
          routerLink: ['/wws-abc-analysis/main'],
          entry: true,
        },
      ]),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/abc-analysis',
        description: 'ABC-Analyse der Artikel nach Umsatz.',
      })
    ),
  ];
};
